import { TransactionKind } from "@/api";
import { TransactionsContainer } from "@/transactions/page.tsx";

export function DeductionTransactions() {
  let kinds = ["deduction", "repayment"] as TransactionKind[]
  let page_title = (
    <div className="space-2">
      <h1 className="text-2xl font-semibold">Deductions & Repayments</h1>
      <span className="text-gray-500 text-sm">
        Review deductions and repayments.
      </span>
    </div>
  );
  return <TransactionsContainer kinds={kinds} titleSection={page_title}/>
}